import { useCallback, useContext, UIEvent, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import classNames from "classnames";
import {
    GridTable,
    GridTableHeader,
    GridTableRow,
} from "../general/Tables/GridTable/GridTable";
import { ImporterContext } from "./importer.context";
import styles from "./ImporterPage.module.scss";
import { ImporterEmptyRow } from "./ImporterEmptyRow";
import { ImporterTableRow } from "./ImporterTableRow";

const rowHeight = 40;
const headerHeight = 140;

export const ImporterPageContent: React.FC = () => {
    const { documentRows } = useContext(ImporterContext);
    const emptyRowsNumber = Math.max(
        5,
        Math.floor((window.innerHeight - headerHeight) / rowHeight) -
            documentRows.length,
    );

    const [leftSticked, setLeftSticked] = useState(false);

    const onScroll = useCallback((e: UIEvent) => {
        setLeftSticked((e.target as HTMLDivElement).scrollLeft > 0);
    }, []);

    return (
        <Scrollbars
            style={{ height: "100%", width: "100%" }}
            onScroll={onScroll}
        >
            <GridTable
                className={classNames(styles.table, {
                    [styles.leftSticked]: leftSticked,
                })}
                noBorder
            >
                <GridTableHeader columnBorders>
                    <GridTableRow columnBorders className={styles.stickyLeft}>
                        <div>#</div>
                        <div />
                        <div>File name</div>
                    </GridTableRow>
                    <div>Status</div>
                    <div>Bank</div>
                    <div>Account number</div>
                    <div>Account type</div>
                    <div>Period</div>
                    <div>Entity</div>
                    <div>Transactions</div>
                </GridTableHeader>

                {documentRows.map((documentRow, index) => (
                    <ImporterTableRow
                        key={documentRow.id}
                        documentRow={documentRow}
                        rowNumber={index + 1}
                    />
                ))}

                {Array.from({ length: emptyRowsNumber }).map((_, index) => (
                    <ImporterEmptyRow
                        key={index}
                        rowNumber={documentRows.length + index + 1}
                    />
                ))}
            </GridTable>
        </Scrollbars>
    );
};
